import React from 'react';

import { Arrow, Wrapper } from './styles';

interface ArrowChangeLabelProps {
    value: number;
    suffix?: string;
    size?: number;
}

export const ArrowChangeLabel = ({ value, suffix = '%', size }: ArrowChangeLabelProps) => {
    if (value === 0) return null;
    const isDecrease = value < 0;
    return (
        <Wrapper $size={size} $isDecrease={isDecrease}>
            <Arrow $isDecrease={isDecrease} />
            {Math.abs(value).toFixed(1)}
            {suffix}
        </Wrapper>
    );
};
